import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Hero from "./hero1";
import HeroMobile, { HeroVideoMobile } from "./heroMobile";
import Hero2 from "./hero2";

const SliderHero = ({ data = [] }) => {
  let slider = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    useTransform: false,
    beforeChange: (current, next) => setActiveSlide(next),
  };

  return (
    <div className="w-full overflow-hidden relative">
      <Slider {...sliderSettings} ref={slider}>
        {data.map((hero, index) => (
          <div key={index} className="relative">
            <div className="hidden min-[860px]:block ">
              {hero._type === "heroWithImage" && <Hero data={hero} />}
              {hero._type === "heroWithVideo" && <Hero2 data={hero} />}
            </div>
            <div className="block min-[860px]:hidden">
              {hero._type === "heroWithImage" && <HeroMobile data={hero} />}
              {hero._type === "heroWithVideo" && (
                <HeroVideoMobile data={hero} />
              )}
            </div>
          </div>
        ))}
      </Slider>
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center justify-center gap-2">
          {data.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                slider.current.slickGoTo(index);
              }}
              aria-label={`Slide ${index + 1}`}
              className={`w-4 h-4 rounded-full ${
                activeSlide === index ? "bg-primary" : "bg-white"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SliderHero;
